import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus--sprite",
  "use": "plus--sprite-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus--sprite\">\n<path d=\"M9.66659 5.66671H5.66659V9.66671H4.33325V5.66671H0.333252V4.33337H4.33325V0.333374H5.66659V4.33337H9.66659V5.66671Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol